/**
 * Key'den parametreleri çıkarır (debug için kullanışlı)
 * @param {string} key - Ayrıştırılacak cache anahtarı
 * @returns {Object} {prefix, params} şeklinde ayrıştırılmış key
 */
export const parseKey = (key) => {
  const parts = key.split(':')
  const prefix = parts[0]
  
  if (parts.length === 1) {
    return { prefix, params: {} }
  }
  
  const params = {}
  for (let i = 1; i < parts.length; i++) {
    const [paramKey, paramValue] = parts[i].split('=')
    if (paramKey && paramValue) {
      try {
        // URL-decoded değeri parse etmeyi dene
        const decodedValue = decodeURIComponent(paramValue)
        
        // JSON olabilir mi?
        if (
          (decodedValue.startsWith('{') && decodedValue.endsWith('}')) || 
          (decodedValue.startsWith('[') && decodedValue.endsWith(']'))
        ) {
          try {
            params[paramKey] = JSON.parse(decodedValue)
          } catch {
            params[paramKey] = decodedValue
          }
        } else {
          params[paramKey] = decodedValue
        }
      } catch {
        params[paramKey] = paramValue
      }
    }
  }
  
  return { prefix, params }
}